import React from 'react';
import _ from 'lodash';
import { Typography } from 'antd';
var {
  Text
} = Typography;
export default function CopyableParagraph(_ref) {
  var {
    children
  } = _ref;
  var sanitizedChildren = _.isEmpty(children) ? children : children[0];
  return /*#__PURE__*/React.createElement(Text, {
    mark: true
  }, sanitizedChildren);
}